import BaseAPI from "../api";

const path: string = "types";

export type detailProjectStatus = {
  idStatus: number;
  projectStatusPercent?: number | null;
  seq?: number;
  projectStatusName?: string;
  idProjectStatusType?: number;
  statusPercent?:number;
};
export interface createType {
  typeNo: string;
  typeName: string;
  isActivities: boolean;
  typeStatus: string;
  idFiscalYear: number | null;
  isEquipment: boolean;
  detailProjectStatus: detailProjectStatus[];
}
export interface updateType {
  typeNo: string;
  typeName: string;
  isActivities: boolean;
  typeStatus: string;
  idFiscalYear: number | null;
  isEquipment: boolean;
  detailProjectStatus: detailProjectStatus[] | undefined;
}

export interface getType {
  idFiscalYear?: number;
  keyword?: string;
  limit?: number;
  page?: number;
}

export class TypesApi extends BaseAPI {
  public static createType(props: createType): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getType(props: getType): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updateType(idType: number, props: updateType): Promise<any> {
    return this.api.patch(`${path}/${idType}`, props).then((res) => res);
  }
  public static getDetailType(idType: number): Promise<any> {
    return this.api.get(`${path}/${idType}`).then((res) => res);
  }
}
